import React from 'react';

import { AccountPaymentMethodList } from 'features/payment/account';

import AuthRequired from 'pages/authentication/components/auth-required';

const PaymentMethods = () => {
  return (
    <AuthRequired>
      <AccountPaymentMethodList />
    </AuthRequired>
  );
};

export default PaymentMethods;
